import Getintouch from '../components/getintouch.js';
import Smallbnr from '../components/smallbanner';
import Team from '../components/team';

export default function About(){
    return (
        <div className="bg-light">
            <Smallbnr />
            <h2 className="p-5">About Us</h2>
            <Team />
            <Getintouch />
            
        </div>
    );
}